import { useEffect, useCallback, useRef, useContext } from "react";
import Cookie from "universal-cookie";
import { NotificationContext } from "../contexts/NotificationContext";
import useService from "./useService";
import { logout } from "../services/Auth";

const cookies = new Cookie()

const useInactivityLogout = () => {
    const {execute} = useService()
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
    const { notify } = useContext(NotificationContext)
    const timeout = 15 * 60 * 1000; // 15 minutes in milliseconds

    // Logout function
    const clearSessionId = useCallback(async() => {
        // Clear any remaining timeout
        if (timerRef.current) {
            clearTimeout(timerRef.current)
        }
       
        const { data } = await execute(() => logout(null))

        if (data != null) {
            cookies.remove("sessionId")
            notify('Your sessionId has been expired. Please login', 'error')
        }
    }, [])

    // Reset the timer on any user activity
    const resetTimer = useCallback(() => {
        if(!cookies.get("sessionId")) return // Exit if no sessionId

        // Clear the previous timer
        if (timerRef.current) {
            clearTimeout(timerRef.current)
        }

        // Set a new timer
        timerRef.current = setTimeout(clearSessionId, timeout)
    }, [clearSessionId, timeout])

    useEffect(() => {
        // Set the initial timer
        resetTimer()

        // List of events that count as activity
        const events = ["keydown", "click"]

        // Add event listeners for each activity event
        events.forEach((event) => {
            window.addEventListener(event, resetTimer)
        })

        // Cleanup event listeners and timeout on unmount
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current)
            }
            events.forEach((event) => {
                window.removeEventListener(event, resetTimer)
            })
        }
    }, [resetTimer])

    return true
}

export default useInactivityLogout
